import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { logout, setcurrentLanguage } from "../Redux/Reducers/authSlice";

const LanguageSwitcher = () => {
    const dispatch = useDispatch();
  
  const { t, i18n } = useTranslation();
    const currentlanguage = useSelector((state) => state.auth?.currentLanguage)
  
  const toggleLanguage = () => {
   
    
    const newLang = i18n.language === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newLang);
    document.documentElement.dir = newLang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = newLang;
  };
  return (
    <button onClick={toggleLanguage} className='switchLang'>
      {t('common.switchLanguage')}
    </button>
  );
};
export default LanguageSwitcher;